import React from "react";
import { makeStyles } from '@material-ui/core/styles';

let useStyles = makeStyles(() => ({
    root:{
        width:472,
        maxWidth:'100%',
        minHeight:581,
        backgroundColor:'#FFFFFF',
        borderRadius:32,
        padding:64,
 
        "@media(max-width : 500px)": {
            padding:'32px 16px',
            display:'flex',
            justifyContent:'center',
            alignItems:'center',
            flexDirection:'column',
            minHeight:'500px',
            margin:'auto',
        },
    },
    gridLogo:{
        display:'flex',
        justifyContent:'center',
        alignItems:'center',
        marginTop:23,
        "@media(max-width : 500px)": {
            '& img':{
                width:250,
            }
        },
    },
}))


const Index = ({ children }) => {

    let classes = useStyles();

    return (
        <div className={classes['root']}>
            <div className={classes['gridLogo']}>
                <img src="/assets/images/register/logoPouyan.png" alt="" />
            </div>
            {children && children}
        </div>
    )
}

export default Index                          